/**
 * @desc 财务画像锚点定位
 */
import styles from './location.scss';
import React, { PureComponent } from 'react';
import { hashHistory } from 'react-router';
import {Event, PicturePageCode} from '../../../../constants/enum';
import {PicturePageLink, PicturePageText} from '../../../../constants/info';
import emitter from '../../../../utils/emitter';
import { goAnchor, getPageCodeByLink } from '../commons';

export default class Location extends PureComponent {
    constructor(props) {
        super(props);
        this.PageIcon = {
            [PicturePageLink[PicturePageCode.OVERVIEW]]: 'icon-gaishu',
            [PicturePageLink[PicturePageCode.INFO]]: 'icon-jibenxinxi',
            [PicturePageLink[PicturePageCode.PUNISH]]: 'icon-jianguanxinxi',
            [PicturePageLink[PicturePageCode.FRAUD]]: 'icon-caiwuwubi',
            [PicturePageLink[PicturePageCode.RISK]]: 'icon-caiwufengxian'
        };
        this.state = {
            data: []
        };
    }

    componentWillMount() {
        emitter.on(Event.PIC_LOA_CHANGE, this.locationChange);
    }
    
    componentWillUnmount() {
        emitter.removeListener(Event.PIC_LOA_CHANGE, this.locationChange);
    }

    locationChange = (data) => {
        this.setState({ data });
    };

    getTitle = () => {
        const { pathname } = hashHistory.getCurrentLocation();
        let title = PicturePageText[getPageCodeByLink(pathname)];
        let icon = this.PageIcon[pathname];

        return ({ icon, title });
    };

    render() {
        const { icon, title } = this.getTitle();
        const { data } = this.state;

        return (
            <div className={styles.location}>
                <div className={styles.title}>
                    <i className={`iconfont ${icon}`}> </i>
                    {title}
                </div>
                <ul className={styles.list}>
                    {
                        data && data.map((d) => {
                            return <li key={d.id} onClick={() => goAnchor(d.id)}>{d.name}</li>;
                        })
                    }
                </ul>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/common/location/Location.jsx